import { Component, Inject, Input, OnInit } from '@angular/core';
import { HomeController } from "@shared/src/controllers/home/home.controller";
import { PartnerAcquireRouteItemDto } from '@shared/src/dtos/route/acquire/PartnerAcquireRouteItemDto';
import { HString } from '@shared/src/public-api';


@Component({
    selector: 'shared-partner-acquire-route-item',
    templateUrl: './shared.partner.acquire.route.item.html',
    styleUrls: ['./shared.partner.acquire.route.item.scss']
})
export class SharedPartnerAcquireRouteItem implements OnInit {

    public useIonic: boolean = false;
    constructor(@Inject('HomeController') protected homeController: HomeController) {
        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    private _partner: PartnerAcquireRouteItemDto;
    @Input()
    set partner(value: PartnerAcquireRouteItemDto) {
        if (this._partner === value)
            return;
        this._partner = value;
        this.wellcome();
    }
    get partner(): PartnerAcquireRouteItemDto {
        return this._partner;
    }

    public messageDescription = "";
    public messageHelp = "";
    public wellcome() {
        this.messageDescription = "";
        this.messageHelp = "";
        if (this.partner != null) {
            this.messageDescription = "ACQUIRED.LINKPERMISSION." + HString.toUpperCase(this.partner.linkPermission) + ".DESCRIPTION";
            this.messageHelp = "ACQUIRED.LINKPERMISSION." + HString.toUpperCase(this.partner.linkPermission) + ".HELP";
        }
    }

    @Input() selected: boolean;

    ngOnInit(): void {
    }

    public getGeneralClass(): string {
        let result = "";
        if (this.selected)
            result += "selected ";

        return result;
    }

}
